// extracted by mini-css-extract-plugin
export default {"container":"styles_container__444BG","content":"styles_content__4b2tj","boxInput":"styles_boxInput__gVHSY","boxEditFormButton":"styles_boxEditFormButton__NO94i"};